<template>
  <div>
    <Balances v-if="windowResize.width > 1023" />
    <RedirectFromManager v-else />
  </div>
</template>

<script>
import Balances from '../components/balances/Balances'
import { state, mutations } from '../components/Observables/balances'
import { useWindowResize } from '@sichern/ui-elements'
import RedirectFromManager from './RedirectFromManager'

export default {
  provide: { state, mutations },
  components: {
    Balances,
    RedirectFromManager
  },
  data() {
    return {
      windowResize: useWindowResize(this)
    }
  },
  created() {
    window.scrollTo(0, 0)
  }
}
</script>